__turbopack_context__.v({
  "actions": "CookiePreferences-module-scss-module__DnwEIG__actions",
  "alwaysOn": "CookiePreferences-module-scss-module__DnwEIG__alwaysOn",
  "button": "CookiePreferences-module-scss-module__DnwEIG__button",
  "buttonPrimary": "CookiePreferences-module-scss-module__DnwEIG__buttonPrimary",
  "buttonSecondary": "CookiePreferences-module-scss-module__DnwEIG__buttonSecondary",
  "categories": "CookiePreferences-module-scss-module__DnwEIG__categories",
  "category": "CookiePreferences-module-scss-module__DnwEIG__category",
  "categoryDescription": "CookiePreferences-module-scss-module__DnwEIG__categoryDescription",
  "categoryHeader": "CookiePreferences-module-scss-module__DnwEIG__categoryHeader",
  "categoryTitle": "CookiePreferences-module-scss-module__DnwEIG__categoryTitle",
  "description": "CookiePreferences-module-scss-module__DnwEIG__description",
  "header": "CookiePreferences-module-scss-module__DnwEIG__header",
  "preferences": "CookiePreferences-module-scss-module__DnwEIG__preferences",
  "slideDown": "CookiePreferences-module-scss-module__DnwEIG__slideDown",
  "statusAccepted": "CookiePreferences-module-scss-module__DnwEIG__statusAccepted",
  "statusBar": "CookiePreferences-module-scss-module__DnwEIG__statusBar",
  "statusLabel": "CookiePreferences-module-scss-module__DnwEIG__statusLabel",
  "statusPending": "CookiePreferences-module-scss-module__DnwEIG__statusPending",
  "statusRejected": "CookiePreferences-module-scss-module__DnwEIG__statusRejected",
  "statusValue": "CookiePreferences-module-scss-module__DnwEIG__statusValue",
  "successMessage": "CookiePreferences-module-scss-module__DnwEIG__successMessage",
  "title": "CookiePreferences-module-scss-module__DnwEIG__title",
  "toggle": "CookiePreferences-module-scss-module__DnwEIG__toggle",
  "toggleInput": "CookiePreferences-module-scss-module__DnwEIG__toggleInput",
  "toggleSlider": "CookiePreferences-module-scss-module__DnwEIG__toggleSlider",
  "toggleWrapper": "CookiePreferences-module-scss-module__DnwEIG__toggleWrapper",
});
